import { EntryType, LabelData, ListNavigationEntry } from "navigation/list/navigation-entry.interface";
import { NavigationMenuItem } from "navigation/list/navigation.interface";
import { Store } from "navigation/list/navigation-store.interface";

type ViewableElement = stages.process.ViewableElement;
type ViewableType = stages.process.ViewableType;

export class ViewableNavigationEntry implements ListNavigationEntry {
	id: string;
	label?: string;
	labelTranslate?: string;
	labelClasses?: string[] | string;
	secondLine?: string;
	secondLineTranslate?: string;
	route: unknown[];
	exact?: boolean;
	disabled?: boolean | ((...args: unknown[]) => boolean);
	icon?: string;
	displayMode?: NAV_ENTRY_DISPLAY_MODE;
	menuItems?: NavigationMenuItem[];
	actions: StringToBoolean;
	sortKey: number;
	valueForAlphabeticalSort: string;
	hasChildren: boolean;
	linkDisabled?: boolean;

	constructor(
		public original: ViewableElement,
		labelData: LabelData,
		readonly entryType: EntryType,
		private store: Store<ViewableElement, ViewableType>,
		private workspaceId: string,
		private pv: string,
	) {
		this.label = labelData.label;
		this.labelTranslate = labelData.labelTranslate;
		this.labelClasses = labelData.labelClasses;
		this.secondLine = labelData.secondLine;
		this.secondLineTranslate = labelData.secondLineTranslate;
		this.valueForAlphabeticalSort = labelData.valueForAlphabeticalSort;
		this.id = store.getIdentifier(original);
		this.route = store.getRoute(original);
		this.actions = original.allowedOperations;
		this.sortKey = original.sortKey;
		this.hasChildren = original.children ? original.children.length > 0 : !original.isLeaf;
	}

	async editDone(newLabel: string, _skipDuplicationCheck: boolean): Promise<void> {
		if (this.original) {
			return this.store.rename(this.original, newLabel, this.workspaceId, this.pv);
		}
	}

	getValueForAlphabeticalSort(): string {
		return this.valueForAlphabeticalSort;
	}
}
